import React, { useEffect, useRef, useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import AccountBoxTwoToneIcon from '@mui/icons-material/AccountBoxTwoTone';
// import AccountTreeTwoToneIcon from '@mui/icons-material/AccountTreeTwoTone';
import ExpandMoreTwoToneIcon from '@mui/icons-material/ExpandMoreTwoTone';
// import InboxTwoToneIcon from '@mui/icons-material/InboxTwoTone';
import LockOpenTwoToneIcon from '@mui/icons-material/LockOpenTwoTone';
import {
  Avatar,
  Box,
  Button,
  Divider,
  List,
  ListItem,
  ListItemText,
  Popover,
  styled,
  Typography,
} from '@mui/material';
import { getFreshToken } from 'src/utils/get-fresh-token';
import { getProfile, ProfileResponse } from 'src/services/users.service';
import { useAppSelector } from 'src/hooks/useStore';

const MenuUserBox = styled(Box)(
  ({ theme }) => `
        background: transparent;
        padding: ${theme.spacing(2)};
        border-radius: 16px;
        border: 1px solid #E5E7EB;
`,
);

const UserBoxText = styled(Box)(
  ({ theme }) => `
        text-align: left;
        padding-left: ${theme.spacing(1)};
`,
);

const UserBoxLabel = styled(Typography)(
  ({}) => `
        font-weight: 500;
        color: #0C2340;
        display: block;
        font-size: 14px;
`,
);

const UserBoxDescription = styled(Typography)(
  ({}) => `
        color: #5B6B80;
        font-size: 12px;
`,
);

const HeaderUserBox = ({ collapsed }: { collapsed: boolean }) => {
  const navigate = useNavigate();
  const ref = useRef<any>(null);

  const [isOpen, setOpen] = useState<boolean>(false);
  const [user, setUser] = useState<ProfileResponse | null>(null);
  const { logout, getIdTokenClaims } = useAuth0();

  const { liveData } = useAppSelector(state => state.sliceTransaction);

  useEffect(() => {
    const fetchUser = async () => {
      const token = await getFreshToken(getIdTokenClaims);
      if (!token) return;

      const profile = await getProfile(token, liveData);
      setUser(profile);
    };
    fetchUser();
  }, [getIdTokenClaims, liveData]);

  const handleOpen = (): void => {
    setOpen(true);
  };

  const handleClose = (): void => {
    setOpen(false);
  };

  const handleLogout = async (event: React.MouseEvent) => {
    event.preventDefault();
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      // Handle error
    }
  };

  return (
    <>
      <div
        key={'userbox'}
        className={`rounded-[20px] shadow-custom bg-white w-full`}
      >
        <button
          color="primary"
          ref={ref}
          onClick={handleOpen}
          className={`flex w-full items-center justify-between p-4 text-left ${
            collapsed ? 'justify-center' : ''
          }`}
        >
          <div
            className={`flex items-center gap-2 ${
              collapsed ? 'justify-center w-full' : ''
            }`}
          >
            <Avatar
              variant="rounded"
              alt={user?.name}
              src={user?.picture}
              sx={{
                width: 32,
                height: 32,
                borderRadius: '8px',
                backgroundColor: '#EAF0F9',
                color: '#00387D',
                fontSize: '14px',
                fontWeight: 700,
              }}
            >
              {user?.given_name?.charAt(0) || 'R'}
            </Avatar>
            {!collapsed && (
              <>
                <UserBoxText sx={{ pl: 1 }}>
                  <UserBoxLabel variant="body1">
                    {user?.given_name || 'User'}
                  </UserBoxLabel>
                  <UserBoxDescription variant="body2"></UserBoxDescription>
                </UserBoxText>
                <ExpandMoreTwoToneIcon sx={{ ml: 1, color: '#5B6B80' }} />
              </>
            )}
          </div>
        </button>
      </div>

      <Popover
        disableScrollLock
        anchorEl={ref.current}
        onClose={handleClose}
        open={isOpen}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        PaperProps={{
          sx: {
            borderRadius: '16px',
            boxShadow: '0 12px 30px rgba(0, 56, 125, 0.14)',
            border: '1px solid #E5E7EB',
            overflow: 'hidden',
          },
        }}
      >
        <MenuUserBox sx={{ minWidth: 210 }} display="flex">
          <Avatar
            variant="rounded"
            alt={user?.name}
            src={user?.picture}
            sx={{
              width: 32,
              height: 32,
              borderRadius: '8px',
              backgroundColor: '#EAF0F9',
              color: '#00387D',
              fontSize: '14px',
              fontWeight: 700,
            }}
          >
            {user?.given_name?.charAt(0) || 'R'}
          </Avatar>
          <UserBoxText>
            <UserBoxLabel variant="body1">
              {user?.given_name || 'User'}
            </UserBoxLabel>
            <UserBoxDescription variant="body2"></UserBoxDescription>
          </UserBoxText>
        </MenuUserBox>
        <Divider sx={{ borderColor: '#E5E7EB' }} />
        <List sx={{ p: 1 }} component="nav">
          <ListItem
            onClick={handleClose}
            button
            to={`/user/profile`}
            component={NavLink}
            sx={{
              borderRadius: '12px',
              margin: '2px 4px',
              '&:hover': {
                backgroundColor: '#F7F9FC',
              },
            }}
          >
            <AccountBoxTwoToneIcon fontSize="small" sx={{ color: '#5B6B80' }} />
            <ListItemText
              primary={'Profile'}
              sx={{
                '& .MuiListItemText-primary': {
                  fontSize: '14px',
                  fontWeight: 500,
                  color: '#0C2340',
                },
              }}
            />
          </ListItem>
          {/* <ListItem
            onClick={handleClose}
            button
            to="applications/mailbox/inbox"
            component={NavLink}
            sx={{
              borderRadius: '12px',
              margin: '2px 4px',
              '&:hover': {
                backgroundColor: '#F7F9FC',
              },
            }}
          >
            <InboxTwoToneIcon fontSize="small" sx={{ color: '#5B6B80' }} />
            <ListItemText
              primary={'Inbox'}
              sx={{
                '& .MuiListItemText-primary': {
                  fontSize: '14px',
                  fontWeight: 500,
                  color: '#0C2340',
                },
              }}
            />
          </ListItem>
          <ListItem
            onClick={handleClose}
            button
            to="applications/projects-board"
            component={NavLink}
            sx={{
              borderRadius: '12px',
              margin: '2px 4px',
              '&:hover': {
                backgroundColor: '#F7F9FC',
              },
            }}
          >
            <AccountTreeTwoToneIcon
              fontSize="small"
              sx={{ color: '#5B6B80' }}
            />
            <ListItemText
              primary={'Projects'}
              sx={{
                '& .MuiListItemText-primary': {
                  fontSize: '14px',
                  fontWeight: 500,
                  color: '#0C2340',
                },
              }}
            />
          </ListItem> */}
        </List>
        <Divider sx={{ borderColor: '#E5E7EB' }} />
        <Box m={1}>
          <Button
            color="primary"
            fullWidth
            onClick={handleLogout}
            sx={{
              borderRadius: '12px',
              backgroundColor: '#B21515',
              color: 'white',
              textTransform: 'none',
              '&:hover': {
                backgroundColor: '#DC2626',
              },
            }}
          >
            <LockOpenTwoToneIcon sx={{ mr: 1 }} />
            Sign out
          </Button>
        </Box>
      </Popover>
    </>
  );
};

export default HeaderUserBox;
